import { useState, useEffect } from 'react';
import { 
  Card, 
  CardBody,
  Table,
  TableHeader,
  TableBody,
  TableColumn,
  TableRow,
  TableCell,
  Button,
  Switch,
  useDisclosure
} from '@nextui-org/react';
import { CreateCouponModal } from './CreateCouponModal';
import { fetchAllCoupons, updateCoupon } from 'common/src/api/coupons';

export default function DiscountCouponsPage() {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const loadCoupons = async () => {
    const { data } = await fetchAllCoupons()
    setCoupons(data || []);
    setLoading(false);
  };

  useEffect(() => {
    loadCoupons();
  }, []);

  const toggleActive = async (id: number, newValue: boolean) => {
    await updateCoupon(id, newValue)
    loadCoupons();
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardBody className="flex flex-row justify-between items-center">
          <h1 className="text-2xl font-bold">Cupones de Descuento</h1>
          <Button 
            color="primary"
            onClick={onOpen}
          >
            Crear Cupón
          </Button>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <Table aria-label="Cupones de descuento">
            <TableHeader>
              <TableColumn>CÓDIGO</TableColumn>
              <TableColumn>DESCUENTO</TableColumn>
              <TableColumn>USOS</TableColumn>
              <TableColumn>EXPIRA</TableColumn>
              <TableColumn>ESTADO</TableColumn>
            </TableHeader>
            <TableBody 
              items={coupons}
              loadingContent={loading ? "Cargando..." : null}
            >
              {(coupon) => (
                <TableRow key={coupon.id}>
                  <TableCell>{coupon.code}</TableCell>
                  <TableCell>
                    {coupon.is_percentage 
                      ? `${coupon.discount_amount}%`
                      : `$${Number(coupon.discount_amount).toLocaleString()}`}
                  </TableCell>
                  <TableCell>
                    {`${coupon.current_uses || 0}/${coupon.max_uses || '∞'}`}
                  </TableCell>
                  <TableCell>
                    {coupon.expires_at 
                      ? new Date(coupon.expires_at).toLocaleDateString('es-CL')
                      : 'No expira'}
                  </TableCell>
                  <TableCell>
                    <Switch
                      isSelected={coupon.is_active}
                      onValueChange={(value) => toggleActive(coupon.id, value)}
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>

      <CreateCouponModal 
        isOpen={isOpen} 
        onClose={onClose}
        onSuccess={loadCoupons}
      />
    </div>
  );
} 